import Marquee from "react-fast-marquee";

// All logos have been pre-processed: transparent background, white subject.
// Guaranteed visible on the dark theme, no CSS filters required.
// Ordered majors-first: Warner Music Group, Sony Music, Universal-family
// imprints, then major-adjacent independents.
const LABELS = [
  { name: "Warner Records", file: "/logos/warner.png" },
  { name: "Sony Music", file: "/logos/sony.png" },
  { name: "Interscope Records", file: "/logos/interscope.png" },
  { name: "Atlantic Records", file: "/logos/atlantic.png" },
  { name: "Island Records", file: "/logos/island.png" },
  { name: "Arista Records", file: "/logos/arista.png" },
  { name: "APG · Artist Partner Group", file: "/logos/apg.png" },
  { name: "Big Loud", file: "/logos/big-loud.png" },
  { name: "Big Loud Rock", file: "/logos/big-loud-rock.png" },
  { name: "Insomniac Records", file: "/logos/insomniac.png" },
  { name: "Blue Highway Records", file: "/logos/blue-highway.png" },
  { name: "Darkroom Records", file: "/logos/darkroom-records.png" },
  { name: "Sunday", file: "/logos/sunday.png" },
];

function LabelLogo({ label, i }) {
  return (
    <div
      data-testid={`logo-${i}`}
      className="mx-10 md:mx-14 flex items-center h-14 md:h-16"
    >
      <img
        src={label.file}
        alt={label.name}
        className="h-full w-auto max-w-[200px] object-contain opacity-70 hover:opacity-100 transition-opacity duration-500"
        loading="lazy"
      />
    </div>
  );
}

export default function LogoWall() {
  const items = [...LABELS, ...LABELS];
  return (
    <section data-testid="home-logowall" className="relative border-y border-white/5 py-8 bg-black">
      <div className="mx-auto max-w-7xl px-6 md:px-10 mb-6">
        <div className="text-xs uppercase tracking-[0.24em] text-zinc-500">
          Trusted by the industry that shapes music
        </div>
      </div>
      <Marquee gradient gradientColor="#000000" gradientWidth={140} speed={32} pauseOnHover>
        {items.map((l, i) => (
          <LabelLogo key={`${l.name}-${i}`} label={l} i={i} />
        ))}
      </Marquee>
    </section>
  );
}
